
import { Map } from 'immutable';
import { dateUtilities } from '../../common';

export const messageSections = {
  content : 'content',
  start : 'publishStartDate',
  end : 'publishEndDate',
  dismissable : 'isDismissable',
  dateRange : 'useDateRange'
}

export function convertMessageToUiFormat(data) {
  if(!data) {
    return new Map({});
  }

  const { content, isDismissable, publishAtUtc, closedAtUtc, useDateRange } = data || {};
  return new Map({
    content: content,
    isDismissable: isDismissable,
    useDateRange: useDateRange,
    publishStartDate: (useDateRange && publishAtUtc) ? dateUtilities.getUserFriendlyFormatFromJson(publishAtUtc) : undefined,
    publishEndDate: (useDateRange && closedAtUtc) ? dateUtilities.getUserFriendlyFormatFromJson(closedAtUtc) : undefined
  });
}

export function mergeData(newData, oldData) {
  const content = newData && newData.get(messageSections.content);
  const startDate = newData && newData.get(messageSections.start);
  const endDate = newData && newData.get(messageSections.end);
  const dismissable = newData && newData.get(messageSections.dismissable);
  const useDateRange = newData && newData.get(messageSections.dateRange);

  const defaultContent = oldData && oldData.get(messageSections.content);
  const defaultStartDate = oldData && oldData.get(messageSections.start);
  const defaultEndDate = oldData && oldData.get(messageSections.end);
  const defaultDismissable = oldData && oldData.get(messageSections.dismissable);
  const defaultUseDateRange = oldData && oldData.get(messageSections.dateRange);

  return {
    content : content !== undefined && content !== null ? content : defaultContent ? defaultContent : "",
    publishStartDate : startDate !== undefined && startDate !== null ? startDate : defaultStartDate ? defaultStartDate : "",
    publishEndDate : endDate !== undefined && endDate !== null ? endDate : defaultEndDate ? defaultEndDate : "",
    isDismissable : dismissable !== undefined && dismissable !== null ? dismissable : defaultDismissable,
    useDateRange : useDateRange !== undefined && useDateRange !== null ? useDateRange : defaultUseDateRange,
  }
}
